// src/components/Header/ShareModal.tsx
import React, { useState } from 'react';
import { X, Copy, Mail, Link2, Check } from 'lucide-react';
import './Modals.scss';

interface ShareModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ShareModal: React.FC<ShareModalProps> = ({ isOpen, onClose }) => {
  const [copied, setCopied] = useState(false);
  const shareUrl = window.location.href;

  if (!isOpen) return null;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content share-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Share Workspace</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="share-section">
            <label htmlFor="share-link">Workspace Link</label>
            <div className="share-input-group">
              <input
                id="share-link"
                type="text"
                value={shareUrl}
                readOnly
                className="share-input"
              />
              <button className="copy-button" onClick={handleCopyLink}>
                {copied ? <Check size={16} /> : <Copy size={16} />}
                {copied ? 'Copied!' : 'Copy'}
              </button>
            </div>
          </div>

          <div className="share-options">
            <button className="share-option-button">
              <Mail className="icon" />
              <span>Share via Email</span>
            </button>
            <button className="share-option-button">
              <Link2 className="icon" />
              <span>Get Shareable Link</span>
            </button>
          </div>

          <div className="share-section">
            <label htmlFor="invite-email">Invite by Email</label>
            <div className="invite-input-group">
              <input
                id="invite-email"
                type="email"
                placeholder="Enter email address"
                className="share-input"
              />
              <button className="invite-button">Invite</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
